import { combineReducers } from 'redux';

import balances from './reducers/balances';
import report from './reducers/report';
import reportOpts from './reducers/report-options';
import selectedCurrency from './reducers/selected-currency';
import selectedEventFilter from './reducers/selected-event-filter';
import selectedTime from './reducers/selected-time';

const rootReducer = combineReducers({
  balances,
  report,
  reportOpts,
  selectedCurrency,
  selectedEventFilter,
  selectedTime
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/beta-dashboard/reducers.js